__webpack_require__.p = "/waste/";